import { createMfeTestpageApp } from '@common/testpage/MfeTestpageApp.js';
import { projectConfig } from '@root/projectConfig.js';

declare let IS_DEV: boolean;
const app = createMfeTestpageApp({
  apiEndpoint: 'api-consent',
  isDev: IS_DEV,
  port: projectConfig.port,
  showClientSelect: true,
  tag: 'tef-coms4cs',
});
app.mount('body');
